import { FC, useRef } from 'react';
import { usePaymentMethod } from '../hooks/PaymentMethod/usePaymentMethod';
import { useUpdatePaymentMethod } from '../hooks/PaymentMethod/useUpdatePaymentMethod';
import { useLoadingAny } from '../hooks/common/useLoadingAny';
import { useLogging } from '../hooks/common/useLogging';
import { useEmitResetWindow } from '../hooks/common/useEmitResetWindow';
import { formatCardBrandName } from '../utils/format';
import { Setting } from '../App';

import { SectionTitle } from '../components/common/SectionTitle';
import { PaymentMethodDetail } from '../components/PaymentMethod/PaymentMethodDetail';
import { NavigationWrapper } from '../components/common/NavigationWrapper';
import { Button } from '../components/common/Button';
import { InformationBox } from '../components/common/InformationBox';

export const PaymentMethod: FC<{ setting: Setting }> = ({ setting }) => {

  const { subscriptionRef, token } = setting;
  const [{ subscription, loadingSubscriptions }] = subscriptionRef;

  const { paymentMethod, loadingPaymentMethod } = 
    usePaymentMethod(subscription, token);
  const [ loadingUpdatePaymentMethod, updatePaymentMethod ] = 
    useUpdatePaymentMethod(subscription, token);

  const loadingAny = useLoadingAny([
    loadingSubscriptions,
    loadingPaymentMethod,
    loadingUpdatePaymentMethod
  ]);

  const rootElementReference = useRef<HTMLDivElement | null>(null);
  useEmitResetWindow(rootElementReference, [paymentMethod]);

  useLogging('PaymentMethod', [paymentMethod]);

  return (
    <div 
      className={`appContainer paymentMethod`}
      ref={rootElementReference}
    >
      <SectionTitle>お支払い方法の確認・変更</SectionTitle>
      <InformationBox title={`現在のお支払い方法`}>
        <PaymentMethodDetail prefix={'カード種別'} value={formatCardBrandName(paymentMethod.brand)}/>
        <PaymentMethodDetail prefix={'カード番号'} value={paymentMethod.maskedNumber}/>
        <PaymentMethodDetail prefix={'有効期限'} value={`${paymentMethod.expiryMonth}月 / ${paymentMethod.expiryYear}年`}/>
      </InformationBox>
      <NavigationWrapper>
        <Button onClick={updatePaymentMethod} disabled={loadingAny}>変更する</Button>
        <Button internalLink={'/'} type="secondary">もどる</Button>
      </NavigationWrapper>
    </div>
  );
};
